// Press release content used both on-page and for PDF generation
export const PRESS = {
  releaseType: 'FOR IMMEDIATE RELEASE',
  dateline: 'London — September 2026',
  headline:
    'ASH — The Witch Trials of Drudenhaus: a two-person immersive Halloween witch-trial opens at COLAB Theatre, London Bridge',
  strap:
    'Can you prove you’re not a witch? A candlelit interrogation for an audience of just two this Halloween season.',
  lede:
    'This Halloween, COLAB Theatre invites audiences to face the Inquisitor in ASH — The Witch Trials of Drudenhaus, a new immersive theatrical trial staged at The Cottage, COLAB’s Tudor house in the heart of London Bridge. In an audience of just two, the accused sit close enough to be personally named, blindfolded, and led by the performer through a candlelit hearing.',
  body: [
    'Rooted in the Bamberg trials, ASH is inspired by the Drudenhaus — or Malefizhaus — the purpose-built witch prison opened in Bamberg in 1627 during one of Europe’s most intense witch persecutions. This is not fantasy horror. It is interrogation, confession, faith and shame.',
    'The signature device is a small dolls-house world that sits between the audience: church, healer’s cottage, ash roads. Every mark that first looks like witchcraft is slowly revealed as proof the village came to her for help. The ash is not a curse. It is a bandage.',
    'Written, directed and performed by Bertie Watkins, ASH is designed for the Halloween period as a compact, repeatable, two-person horror format — one table, candlelight, sound, darkness, and an audience of just two.'
  ],
  quote: {
    text:
      '“ASH is a live trial. You are the accused. History is close enough to breathe on you.”',
    attribution: 'Bertie Watkins, writer and director'
  },
  keyFacts: [
    { label: 'Title', value: 'ASH — The Witch Trials of Drudenhaus' },
    { label: 'Company', value: 'COLAB Theatre' },
    { label: 'Writer, Director & Performer', value: 'Bertie Watkins' },
    { label: 'Venue', value: 'The Cottage, COLAB Theatre' },
    { label: 'Address', value: '169a Borough High Street, London SE1 1HR' },
    { label: 'Season', value: 'Halloween 2026' },
    {
      label: 'Format',
      value: 'Immersive, two-person audience per show'
    },
    { label: 'Age guidance', value: '16+' },
    {
      label: 'Content guidance',
      value:
        'Blindfolds and physical contact from the performer; near darkness; themes of persecution and interrogation. Safeword and opt-outs available.'
    },
    { label: 'Running time', value: 'c. 50 minutes' },
    { label: 'Tickets', value: 'From £45' },
    { label: 'Booking', value: 'ashthewitchtrials.co.uk' }
  ],
  reviews: [
    {
      quote:
        'Terrifying, intimate and unlike anything I have ever sat through.',
      attribution: 'Tester Audience'
    },
    {
      quote:
        'The Inquisitor looked me in the eye and I forgot how to breathe.',
      attribution: 'Tester Audience'
    },
    {
      quote:
        'History pressed right up against your face. Genuinely unsettling.',
      attribution: 'Tester Audience'
    }
  ],
  press: {
    name: 'COLAB Theatre Press Office',
    email: 'producer@colabtheatre.co.uk',
    phone: '07724 633985',
    web: 'ashthewitchtrials.co.uk'
  },
  boilerplate:
    'About COLAB Theatre — COLAB Theatre are one of London’s leading immersive theatre companies, creating close-contact, story-driven experiences for small audiences across a portfolio of atmospheric venues in and around London Bridge. Recent work has spanned immersive escape-rooms, live-action horror and site-specific theatre, with a focus on new writing, tight ensembles and intimate audience formats. Find out more at colabtheatre.co.uk.',
  ends: '— ends —',

  blurbs: {
    fifty: `Can you prove you’re not a witch? ASH — The Witch Trials of Drudenhaus is a candlelit, two-person immersive theatre trial for Halloween 2026. Face the Inquisitor at The Cottage, COLAB Theatre’s Tudor house in London Bridge. Blindfolds. Close contact. Real fear. Fifty terrifying minutes. From £45. Age 16+.`,
    twoHundred: `Can you prove you’re not a witch?

This Halloween, COLAB Theatre invites two audience members at a time into ASH — The Witch Trials of Drudenhaus, a candlelit, close-contact theatrical trial at The Cottage, their Tudor house on Borough High Street.

Rooted in the Bamberg trials of 1627, ASH is not fantasy horror. It is interrogation, confession, faith and shame — history close enough to breathe on you. A single Inquisitor sits across a wooden table strewn with candles, ash and the miniature dolls-house world of a village. Every mark that looks like witchcraft is slowly revealed as proof that the village came to her for help. The ash is not a curse. It is a bandage.

Written, directed and performed by Bertie Watkins, ASH is one of London’s most intimate immersive experiences — an audience of just two, one performer, fifty minutes in the dark. Expect blindfolds, physical handling, near-total darkness and a Halloween trial you will feel in your teeth.

From £45. Age 16+. The Cottage, COLAB Theatre, 169a Borough High Street, London SE1 1HR. Halloween 2026.

Face the Inquisitor. Find the key. Leave before the House names you.`
  }
};

export const PRESS_IMAGES = [
  {
    file: '/ash/image-1-1.png',
    focus: { x: 0.55, y: 0.55 },
    caption:
      'ASH — The candlelit interrogation table at The Cottage, COLAB Theatre, London Bridge. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/bertie-portrait.png',
    focus: { x: 0.5, y: 0.26 },
    caption:
      'Bertie Watkins as the Inquisitor in ASH — The Witch Trials of Drudenhaus. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/bertie-landscape.png',
    focus: { x: 0.58, y: 0.25 },
    caption:
      'Bertie Watkins as the Inquisitor leaning over the chained accused at the interrogation table. ASH — The Witch Trials of Drudenhaus. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/image-5-1.png',
    focus: { x: 0.5, y: 0.55 },
    caption:
      'The signature device — the miniature village on the table. ASH. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/image-6-1.png',
    focus: { x: 0.5, y: 0.5 },
    caption:
      'The trial by candlelight. ASH audience trial. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/image-7-1.png',
    focus: { x: 0.65, y: 0.5 },
    caption:
      'The Cottage — COLAB Theatre’s Tudor house on Borough High Street. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/bertie-shadowed.png',
    focus: { x: 0.75, y: 0.25 },
    caption:
      'Bertie Watkins as the Inquisitor, half in shadow, at the Drudenhaus table. ASH — The Witch Trials of Drudenhaus. Photo: Alex Walton for COLAB Theatre.'
  },
  {
    file: '/ash/ash-poster.png',
    focus: { x: 0.5, y: 0.3 },
    keyArt: true,
    caption:
      'ASH — The Witch Trials of Drudenhaus. Official key art poster, Halloween 2026, The Cottage, London Bridge. Photo: Alex Walton for COLAB Theatre.'
  }
];
